if (!customElements.get('deployer-collection-filter-form')) {
  customElements.define(
    'deployer-collection-filter-form',
    class DeployerCollectionFilterForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('#DeployerCollectionFiltersForm');
        if (!this.form) return;

        this.onChangeHandler = this.onChange.bind(this);
        this.checkboxes = Array.from(this.form.querySelectorAll('.deployer-facets__checkbox'));
        this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', this.onChangeHandler));

        this.applyDefaultFilter();
        this.toggleActiveFacets();
      }

      disconnectedCallback() {
        if (!this.checkboxes || !this.onChangeHandler) return;
        this.checkboxes.forEach((checkbox) => checkbox.removeEventListener('change', this.onChangeHandler));
      }

      applyDefaultFilter() {
        const hasActive = this.checkboxes.some((checkbox) => checkbox.checked);
        if (hasActive) return;

        const defaultFacet = this.querySelector('deployer-facets[data-default="true"] .deployer-facets__checkbox');
        if (!defaultFacet) return;

        defaultFacet.checked = true;
        defaultFacet.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onChange(event) {
        event.preventDefault();
        const current = event.currentTarget;

        this.checkboxes.forEach((checkbox) => {
          if (checkbox !== current) checkbox.checked = false;
        });

        this.toggleActiveFacetsFromInputs();
        this.renderPage(current.checked ? current.name : '', current.checked ? current.dataset.value : '');
      }

      renderPage(searchParamName, searchParamValue) {
        const searchParams = new URLSearchParams(window.location.search);
        const paramNames = new Set(this.checkboxes.map((checkbox) => checkbox.name));

        paramNames.forEach((paramName) => searchParams.delete(paramName));
        searchParams.delete('page');

        if (searchParamName && searchParamValue) {
          searchParams.set(searchParamName, searchParamValue);
        }

        const sections = this.sectionsToRender;
        sections.forEach((section) => {
          const url = `${window.location.pathname}?section_id=${section.sectionId}&${searchParams.toString()}`;
          this.renderContentsFromFetch(url, section.selector);
        });

        this.updateURLHash(searchParams);
      }

      toggleActiveFacets() {
        const urlParams = new URLSearchParams(window.location.search);
        this.querySelectorAll('deployer-facets').forEach((facet) => {
          const input = facet.querySelector('input');
          if (!input) return;
          if (urlParams.get(input.name) === input.value) {
            facet.setAttribute('data-active', 'true');
            input.checked = true;
          } else {
            facet.removeAttribute('data-active');
            input.checked = false;
          }
        });
      }

      toggleActiveFacetsFromInputs() {
        this.querySelectorAll('deployer-facets').forEach((facet) => {
          const input = facet.querySelector('input');
          if (!input) return;
          if (input.checked) {
            facet.setAttribute('data-active', 'true');
          } else {
            facet.removeAttribute('data-active');
          }
        });
      }

      async renderContentsFromFetch(url, selector) {
        if (!url || !selector) return;
        try {
          const response = await fetch(url);
          const html = await response.text();
          this.renderContents(html, selector);
        } catch (error) {
          console.error('Failed to fetch filter data:', error);
        }
      }

      renderContents(html, selector) {
        const target = document.querySelector(selector);
        const replacement = this.getSectionInnerHTML(html, selector);
        if (!target || !replacement) return;
        target.innerHTML = replacement;
      }

      updateURLHash(searchParams) {
        const query = searchParams.toString();
        const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
        history.replaceState({ searchParams: query }, '', url);
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || null;
      }

      get sectionsToRender() {
        const sections = [];

        const mainCollection = document.querySelector('[data-ref="main-collection"]');
        const mainCollectionSectionId = mainCollection?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (mainCollectionSectionId) {
          sections.push({
            selector: '[data-ref="main-collection"]',
            sectionId: mainCollectionSectionId,
          });
        }

        const deployerFilters = document.querySelector('#deployer-collection-filters');
        const deployerFiltersSectionId = deployerFilters?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (deployerFiltersSectionId) {
          sections.push({
            selector: '#deployer-collection-filters',
            sectionId: deployerFiltersSectionId,
          });
        }

        return sections;
      }
    },
  );
}
